export default {
  SET_selectedHeaders(state, value) {
    state.selectedHeaders = value;
  },
};
